<template>
  <v-container fluid class="fill-height primary" style="height: 100vh">
    <v-row align="center" justify="center">
      <v-col cols="12" sm="6" md="4" lg="3">
        <v-card>
          <v-form @submit.prevent="signin">
            <v-container>
              <v-row justify="center">
                <v-icon color="primary" size="128">mdi-account</v-icon>
              </v-row>
              <v-alert type="error" v-show="error.message">{{ error.status + ' ' + error.message }}</v-alert>
              <v-text-field
              v-model="username"
              label="아이디"
              outlined
              ></v-text-field>
              <v-text-field
              v-model="password"
              label="비밀번호"
              type="password"
              outlined></v-text-field>
              <v-btn block color="primary" x-large type="submit" :loading="loading">로그인</v-btn>
            </v-container>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      username: '',
      password: '',
      loading: false,
      error: {
        status: 500,
        message: ''
      }
    }
  },
  methods: {
    async signin () {
      if (this.loading) return
      this.loading = true
      const body = {
        username: this.username,
        password: this.password
      }
      try {
        await this.$store.dispatch('user/signin', body)
        location.href = '/'
      } catch (err) {
        this.error.status = err.status
        this.error.message = err.message
      }
      this.loading = false
    }
  }
}
</script>
